import type { ReactNode } from 'react'

import { TagContextProvider } from '../../utils/tag.context'

import * as styles from './tag.styles'

export type Variant = 'default' | 'highlight' | 'success' | 'warning' | 'error'
export type Size = 'medium' | 'small'

type Props = {
  children: ReactNode
  size?: Size
  variant?: Variant
  className?: string
}

export const Tag = ({
  size = 'medium',
  variant = 'default',
  children,
  className,
  ...rest
}: Props) => (
  <TagContextProvider size={size} variant={variant}>
    <div
      className={className}
      css={[
        styles.container,
        styles.containerSize[size],
        styles.background[variant],
      ]}
      data-testid="tag"
      {...rest}
    >
      {children}
    </div>
  </TagContextProvider>
)
